import { sanitizeLineBreaks } from '~utils/string'

type SanitizedTextProps = Readonly<{ text: string }>

const SanitizedText = ({ text }: SanitizedTextProps) => {
  return (
    <>
      {text.split('\n').map((line, index) => (
        <span key={index} className="break-words">
          {sanitizeLineBreaks(line)}
          <br />
        </span>
      ))}
    </>
  )
}

export default SanitizedText
